import Swiper, { Navigation, Pagination, Thumbs, EffectFade } from 'swiper'
import { stopVideo } from './videos'

export default function() {

    // Gallery block carousel
    Swiper.use([Thumbs, Navigation, Pagination, EffectFade])

    // const galleryThumbs = new Swiper('[data-gallery-thumbs]', {
    //     loop: false,
    //     slidesPerView: 'auto',
    //     spaceBetween: 0,
    //     watchSlidesProgress: true,
    //     navigation: {
    //         nextEl: '[data-gallery-thumbs-next]',
    //         prevEl: '[data-gallery-thumbs-prev]',
    //     },
    //     on: {
    //         slideChange
    //     },
    // })

    const gallery = new Swiper('[data-gallery]', {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        effect: 'fade',
        // thumbs: {
        //     swiper: galleryThumbs,
        // },
        // pagination: {
        //     el: '[data-gallery-pagination]',
        //     type: 'fraction',
        // },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        on: {
            slideChange
        },
    })

    const swiperHome = new Swiper('.swiper-home', {
        loop: false,
        slidesPerView: 1,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: "true,"
        },
    
    })

    // Stop videos
    function slideChange({ slides, previousIndex }) {
        stopVideo(slides[previousIndex])
    }

}